import {
  modelLibURLPrefix,
  modelVersion,
  type AppConfig,
} from "@mlc-ai/web-llm";

export interface ModelOption {
  id: string;
  label: string;
  downloadGB: number;
  runtimeMB: number;
  note: string;
}

export const MODEL_OPTIONS: ModelOption[] = [
  {
    id: "Qwen2.5-Coder-0.5B-q4f16_1-MLC",
    label: "Qwen 2.5 Coder 0.5B Base",
    downloadGB: 0.290,
    runtimeMB: 944.62,
    note: "smallest and fastest FIM model",
  },
  {
    id: "Qwen2.5-Coder-1.5B-q4f16_1-MLC",
    label: "Qwen 2.5 Coder 1.5B Base",
    downloadGB: 0.880,
    runtimeMB: 1_629.75,
    note: "default; higher-quality FIM model",
  },
];

export const DEFAULT_MODEL_ID = "Qwen2.5-Coder-1.5B-q4f16_1-MLC";

const MODEL_LIBRARY_ROOT = modelLibURLPrefix + modelVersion;

export const SLOPAI_APP_CONFIG: AppConfig = {
  model_list: [
    {
      model: "https://ai.sloppy.at/models/Qwen2.5-Coder-0.5B-q4f16_1-MLC/resolve/main/",
      model_id: "Qwen2.5-Coder-0.5B-q4f16_1-MLC",
      model_lib: `${MODEL_LIBRARY_ROOT}/Qwen2-0.5B-Instruct-q4f16_1_cs1k-webgpu.wasm`,
      low_resource_required: true,
      vram_required_MB: 944.62,
      overrides: { context_window_size: 2_048 },
    },
    {
      model: "https://ai.sloppy.at/models/Qwen2.5-Coder-1.5B-q4f16_1-MLC/resolve/main/",
      model_id: "Qwen2.5-Coder-1.5B-q4f16_1-MLC",
      model_lib: `${MODEL_LIBRARY_ROOT}/Qwen2-1.5B-Instruct-q4f16_1_cs1k-webgpu.wasm`,
      low_resource_required: true,
      vram_required_MB: 1_629.75,
      overrides: { context_window_size: 2_048 },
    },
  ],
};

export function modelById(id: string): ModelOption {
  const model = MODEL_OPTIONS.find((candidate) => candidate.id === id);
  if (!model) throw new Error(`Unknown model: ${id}`);
  return model;
}
